import classNames from 'classnames';

export const Bottom = ({ children, className, ...r }) => {
  const classnames = classNames(
    'bottom-options flex',
    className
  );

  return (
    <div className={classnames} {...r}>
      {children}
    </div>
  );
};
